import DialogPR from "./DialogPR";

export default DialogPR;
